import packageJson from '../../package.json';

const getEnvName = () => {
  if (typeof window === 'undefined') {
    return null;
  } else if (window.location.host.split('.')[0] === 'ondemand') {
    return 'prod';
  } else {
    return 'staging';
  }
};

export interface IAnalyticsConfig {
  domain: string;
  customer: string;
  appName: string;
  appType: string;
  appVersion: string;
  deviceType: string;
  requirementsVersion: string;
  msgTriggeredBy: string;
  startSession: string;
  settings: { logLevel: string; [key: string]: any };
  appEnvName: string | null;
  debugAppEvents?: boolean;
  cwvVerbose: boolean;
  cwvEnabled: boolean;
}

const defaultConfig: IAnalyticsConfig = {
  domain: 'video',
  customer: 'Charter',
  appName: 'SpectrumOnDemand',
  appType: 'Web',
  appVersion: packageJson.version,
  deviceType: 'webBrowser',
  requirementsVersion: '2.792',
  msgTriggeredBy: 'user',
  startSession: 'SpectrumOnDemand_startSession',
  settings: { logLevel: 'error' },
  appEnvName: getEnvName(),
  cwvVerbose: true,
  cwvEnabled: true,
};

export default defaultConfig;
